import { ButtonLink } from '@app/components/base/ButtonLink';
import { useToast } from '@app/core/notifications';
import { auditReports } from '@mi-front/api-clients';
import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useClient } from '../../../../../../../../../core/auth/profile/hooks/useClient';
import { useReportCtx } from '../../../../../../../../../core/reports/report-ctx';
import { useStationsWithAudit } from '../../../../../../../hooks/useStationsWithAudit';
import { GipReportType } from '../../../config/form/types';
import { mapValuesToGipReportDataDto } from '../../../config/utils/gip-report-values-to-data-dto';
import { GipReportCreateModal } from './CreateModal';

type Props = {
  onCreate: (name: string, config: auditReports.GipReportDataDto) => Promise<{ id: string }>;
};

export const GipReportCreateModalContainer = ({ onCreate }: Props) => {
  const { values, isLoading } = useReportCtx<GipReportType>();
  const { $t } = useIntl();
  const { notifyInfo } = useToast();
  const [show, setShow] = useState(false);
  const [reportName, setReportName] = useState('');
  const stations = useStationsWithAudit();
  const client = useClient();

  useEffect(() => {
    setReportName(`GIP Report ${moment().format('DD/MM/YY')} ${moment().format('HH:mm')}`);
  }, [show]);

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="success"
        startIcon={<AddIcon />}
        onClick={() => setShow(true)}
        disabled={isLoading}
      >
        <FormattedMessage id="audit.gipReport.info.createBtn" defaultMessage="Guardar reporte" />
      </Button>
      <GipReportCreateModal
        show={show}
        onHide={() => setShow(false)}
        onCreate={async () => {
          try {
            const result = await onCreate(
              reportName,
              mapValuesToGipReportDataDto(client.id, values, stations),
            );

            notifyInfo(
              $t({
                id: 'audit.gipReport.createModal.createdNotification',
                defaultMessage: 'Reporte creado',
              }),
              {
                action: (
                  <ButtonLink to={`/audit/saved-reports/${result.id}`}>
                    {$t({
                      id: 'audit.gipReport.createModal.createdNotificationLink',
                      defaultMessage: 'Ver reporte',
                    })}
                  </ButtonLink>
                ),
              },
            );

            setShow(false);
          } catch (error) {
            notifyInfo(
              $t({
                id: 'audit.gipReport.exportModal.createdNotificationError',
                defaultMessage: 'Error al crear el reporte',
              }),
            );
          }
        }}
        reportName={reportName}
        setReportName={setReportName}
      />
    </>
  );
};
